export class FileRestoreData {
    'files';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<Path>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FileRestoreData.attributeTypeMap;
    }
    constructor() {
    }
}
